import { Fragment, useState, useRef, useEffect } from "react";
import classes from "./Slider.module.css";
import demoImg from "../../../assets/images/img-placeholder-2.png";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

/**
 * props list: {data}
 */

const Slider = (props) => {
  const [imgIndex, setImgIndex] = useState(0);
  const [isEnlarged, setIsEnlarged] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const imgRef = useRef(null);

  const imgArr = props.data.image;

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      // Enter fullscreen
      if (imgRef.current) {
        if (imgRef.current.requestFullscreen) {
          imgRef.current
            .requestFullscreen()
            .then(() => {
              setIsFullscreen(true);
            })
            .catch(() => {
              console.log("Fullscreen request denied");
            });
        }
      }
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          setIsFullscreen(false);
        });
      }
    }
  };

  // Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  const nextClick = () => {
    if (imgIndex + 1 < imgArr.length) {
      setImgIndex((prev) => prev + 1);
    } else {
      setImgIndex((prev) => prev + 1 - imgArr.length);
    }
  };

  const prevClick = () => {
    if (imgIndex > 0) {
      setImgIndex((prev) => prev - 1);
    } else {
      setImgIndex(imgArr.length - 1);
    }
  };

  const indexContent = `${imgIndex + 1} / ${imgArr.length}`;

  let imgContent;
  let itemContent;

  if (props.data && props.data.image.length > 0) {
    imgContent = (
      <img
        ref={imgRef}
        src={imgArr[imgIndex].imgData.URL}
        className={isEnlarged ? classes.enlarged : ""}
      />
    );
    itemContent = (
      <Fragment>
        <div className={classes.nav}>
          <button onClick={prevClick} title="Previous">
            <NavigateBeforeIcon />
          </button>
          <span>{indexContent}</span>
          <button onClick={nextClick} title="Next">
            <NavigateNextIcon />
          </button>
          <button
            onClick={() => setIsEnlarged(!isEnlarged)}
            className={classes["enlarge-btn"]}
            title={isEnlarged ? "Zoom out" : "Zoom in"}
          >
            {isEnlarged ? <ZoomInMapIcon /> : <ZoomOutMapIcon />}
          </button>
          <button
            onClick={handleFullscreen}
            className={classes["fullscreen-btn"]}
            title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
          >
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </button>
        </div>
        <div className={classes.info}>
          <ul>
            <li>
              <span className={classes.label}>Tên: </span>
              {imgArr[imgIndex].imgData.name}
            </li>
            <li>
              <span className={classes.label}>Phân loại: </span>
              {imgArr[imgIndex].imgData.category}
            </li>
          </ul>
        </div>
      </Fragment>
    );
  } else if (imgArr.length === 0) {
    imgContent = <img src={demoImg} />;
    itemContent = <p className={classes.nort}>Món ăn này chưa có hình ảnh.</p>;
  }

  return (
    <div className={classes.container}>
      {imgContent}
      {itemContent}
    </div>
  );
};

export default Slider;
